import flat from 'flat';

import { Language } from '@/constants/language';

import englishMessage from './en.json';
// import romanianMessage from './ro.json';

export type LocaleTranslation = typeof englishMessage;

const messages: Record<Language, LocaleTranslation> = {
  [Language.English]: englishMessage
};

const traverse = (obj: any, path = ''): any => {
  if (obj === null) {
    return null;
  }

  const result: any = {};

  if (typeof obj === 'object') {
    Object.keys(obj).forEach((key) => {
      result[key] = traverse(obj[key], path ? `${path}.${key}` : key);
    });
  } else {
    return path;
  }

  return result;
};

export const translations: LocaleTranslation = traverse(englishMessage);

export const getTranslationMessages = (language: Language): any => flat(messages[language]);
